import { ITender } from "@/interfaces/tender"


const formatTenderName = (tender: ITender) => {
  const formatList = (items: string[]): string => {
    const uniqueItems = Array.from(new Set(items.map(item => item.trim())))
    const shownItems = uniqueItems.slice(0, 5)
    const finalName = shownItems.join(', ')
    return uniqueItems.length > 5 ? `${finalName}...` : finalName
  }
  if (tender.source === 'xarid_uzex') {
    const lots = tender.lots
    if (lots && lots.length > 0) {
      return formatList(lots.map(lot => lot.name))
    }
  }
  if (tender.source === 'xt_xarid') {
    return formatList(tender.name.split(','))
  }
  return tender.name
}

export { formatTenderName }